import type { TypedThunk } from 'src/store/types'
import { getPreviouslyPlayedCategory } from 'src/utils/loadGameInfoGetInitialProps'

import { actions } from './slice'

export const { setPlayedGames, clearPlayedGames, setLayout, setLoaded } = actions

export const getPlayedGames =
  (cookies?: string): TypedThunk =>
  (dispatch, getState, { errorHandler }) => {
    getPreviouslyPlayedCategory(cookies)
      .then((body) => {
        dispatch(setPlayedGames({ games: body.category.products }))
        dispatch(setLayout(body?.layout || ''))
      })
      .catch((err) => {
        dispatch(
          errorHandler(err, {
            type: 'getProductLayout',
            url: `/v1/product-layout?brandName=${process.env.BRAND_NAME}`,
            browser: 'yes',
          }),
        )
      })
      .finally(() => dispatch(setLoaded(true)))
  }
